export default {
  data() {
    return {
      keys: {
        base: ['sum', "count"], // "income_confirmation"],
        comp: ['sum', "count"],
        item: ['id', 'value', 'confirmed']
      },
      key_map: {
        sum: 'Soma',
        count: 'Qtd',
        items: 'Items',
        value: 'Valor',
        income_confirmation: 'Confirmação',
      },
    }
  },
}